import * as AppConstants from 'app/AppConstants';

const initialState = () => ({
  layoutFrameStyles: {},
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.LAYOUT_FRAME__LOAD_FINISHED: {
      const {frameId, styles} = action.payload;

      return {
        ...state,
        layoutFrameStyles: {
          ...state.layoutFrameStyles,
          [frameId]: {
            ...styles,
          },
        },
      };
    }
    default:
      return state;
  }
};
